import { Component, Input } from '@angular/core';
import { TvIcon } from './icon.enum';

@Component({
    selector: 'tvcore-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    standalone: false
})
export class IconComponent {
	@Input()
	name: TvIcon | string;

	readonly TvIcon = TvIcon;
}
